<template>
	<div class="drawer">
		<el-drawer
		size="80%"
		title="商品套餐"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<div style="padding:0 30px;">
				<!-- <div class="label" >请录入以下商品条码：</div> -->
				<!-- <div v-if="groupInfo.basic_info">
					<div style="line-height: 40px;" v-for="(item,index) in groupInfo.basic_info.items" :key="index">
						{{index+1}}. 
						<span style="margin-left:5px;">{{item.goods_name}}</span> 
						<span style="padding:0 30px;">{{item.sku_value}}</span>
						{{item.count}}{{item.unit}}
					</div>
				</div> -->
				<!-- <el-input style="width:300px;" v-model="scanningCodeInput" @keyup.enter.native="clickScanningCodeInput" size="mini">
					<template slot="prepend">录入条码</template>
				</el-input> -->
				<el-table :data="tableData" style="width: 100%;margin-bottom: 20px;margin-top: 30px;" size="mini" row-key="tableKey" default-expand-all>
					<el-table-column type="expand">
						<template slot-scope="props">
							<div v-if="!$public.isNull(props.row.goodsList)">
								<!-- <el-tag style="margin: 5px;"
								v-for="(item,index) in props.row.goodsList"
								:key="index"
								closable
								@close="del_goods(props.row,item)">
									<span v-if="props.row.goodsType===3">{{item.goodsName}}</span>
									{{item.customCode}}
								</el-tag> -->
							</div>
							<!-- <div v-else>无条码</div> -->
						</template>
					</el-table-column>
					<el-table-column label="商品名称" width="250">
						<template slot-scope="scope">
							{{scope.row.goodsName}}
						</template>
					</el-table-column>
					<el-table-column label="品牌" width="100">
						<template slot-scope="scope">
							{{scope.row.brand}}
						</template>
					</el-table-column>
					<el-table-column label="规格" >
						<template slot-scope="scope">
							<div v-for="(item,index) in scope.row.skuList" :key="index">{{index+1}}. {{item.name}}</div>
						</template>
					</el-table-column>
					<el-table-column label="数量" width="60">
						<template slot-scope="scope">
							{{scope.row.num}}
						</template>
					</el-table-column>
					<el-table-column label="单位" width="80">
						<template slot-scope="scope">
							<div v-for="(item,index) in scope.row.wapList" :key="index">{{index+1}}. {{item.name}}</div>
						</template>
					</el-table-column>
				</el-table>
				<el-row>
					<el-col :span="5" :offset="19">
						<el-button style="width:200px;margin-top:50px;" type="primary" @click="submit">已录入完成</el-button>
					</el-col>
				</el-row>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import delSale from "../../../../util/delSale.js"
	export default {
		data() {
			return {
				drawerStatus:false,
				scanningCodeInput:'',
				tableData:[],
				o:null,
			}
		},
		computed:{
		},
		props:{
			groupItem:{
				default:()=>{
					return {}
				}
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.o = new delSale();
				this.drawerStatus = true;
				console.log(this.groupItem)
				
				let arr = []
				for(let i=0;i<this.groupItem.group_items.length;i++){
					let goods = this.groupItem.group_items[i];
					let skuList = []
					for(let a=0;a<goods.sku_list.length;a++){
						if(goods.join_skus.indexOf(goods.sku_list[a].id)>-1){
							skuList.push(goods.sku_list[a])
						}
					}
					let wayList = []
					for(let a=0;a<goods.saleway_list.length;a++){
						if(goods.join_packing_way.indexOf(goods.saleway_list[a].id)>-1){
							wayList.push(goods.saleway_list[a])
						}
					}
					let one = {
						tableKey:Math.random(),
						"goodsId": goods.goods_id,
						"goodsName": goods.goods_name,  
						"goodsType": goods.goods_type,
						"brand": goods.brand_name,
						"categoryId": this.groupItem.category_info._id,
						"categoryName": this.groupItem.category_info.name,
						"skuList": skuList,
						"wayList":  wayList,
						"num": goods.use_num,
						goodsList:[],
					}
					arr.push(one)
				}
				if(!this.$public.isNull(this.groupItem.groupTableData)){
					for(let i=0;i<arr.length;i++){
						arr[i].goodsList = this.groupItem.groupTableData[i].goodsList;
					}
				}
				this.tableData = arr;
				for(let i=0;i<this.tableData.length;i++){
					this.tableData[i].index=i;
					for(let a=0;a<this.tableData[i].goodsList.length;a++){
						this.tableData[i].goodsList[a].oneIndex = i;
						this.tableData[i].goodsList[a].twoIndex = a;
					}
				}
			})
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			// clickScanningCodeInput(){
			// 	this.getScanData(this.scanningCodeInput)
			// },
			// getScanData(code) {
			// 	this.scanningCodeInput = ''
			// 	this.o.searchGoods(code).then((goods)=>{
			// 		let num = 0;
			// 		for(let i=0;i<this.tableData.length;i++){
			// 			console.log(this.tableData[i])
			// 			for(let a=0;a<this.tableData[i].goodsList.length;a++){
			// 				if(this.tableData[i].goodsList[a].customCode===goods.customCode){
			// 					num = num+1;
			// 				}
			// 			}
			// 		}
			// 		let state = false;
			// 		for(let i=0;i<this.tableData.length;i++){
			// 			let item = this.tableData[i];
			// 			if(goods.goodsId===item.goodsId){  // goodsId 匹配
			// 				for(let a=0;a<item.skuList.length;a++){
			// 					if(item.skuList[a].id===goods.skus){  // skus 匹配
			// 						for(let b=0;b<item.wayList.length;b++){
			// 							for(let c=0;c<goods.saleWays.length;c++){
			// 								if(goods.saleWays[c].packing_way_id===item.wayList[b].id){  // 单位匹配
			// 									if(this.tableData[i].goodsList.length===this.tableData[i].num){
			// 										this.$message({
			// 											message: goods.goodsName+' 只能录入'+ this.tableData[i].num+'个',
			// 											type: 'error'
			// 										});
			// 										return ;
			// 									}else{
			// 										state = true;
			// 										this.tableData[i].goodsList.push({
			// 											tableKey:Math.random(),
			// 											customCode:goods.customCode,
			// 											"goodsId": goods.goodsId,
			// 											"goodsName": goods.goodsName,  
			// 											"goodsType": goods.goodsType,
			// 											"brand": goods.brand,
			// 											"categoryId": goods.categoryId,
			// 											"categoryName": goods.categoryName,
			// 											"skus": goods.skus,
			// 											"skuValue": goods.skuValue,
			// 											"unitId":  goods.saleWays[c].packing_way_id,
			// 											"unit":  goods.saleWays[c].packing_way_name,
			// 											"num": 1,
			// 										})
			// 									}
			// 								}
			// 							}
			// 						}
			// 					}else{
			// 						console.log("规格不匹配")
			// 						// this.$message({
			// 						// 	message: '套餐内没有该商品!!',
			// 						// 	type: 'error'
			// 						// });
			// 					}
			// 				}
							
			// 			}else{
			// 				this.$message({
			// 					message: '套餐内没有该商品!',
			// 					type: 'error'
			// 				});
			// 			}
			// 		}
			// 		if(state===true){
			// 			this.$message({
			// 				message: '操作成功',
			// 				type: 'success'
			// 			});
			// 			for(let i=0;i<this.tableData.length;i++){
			// 				this.tableData[i].index=i;
			// 				for(let a=0;a<this.tableData[i].goodsList.length;a++){
			// 					this.tableData[i].goodsList[a].oneIndex = i;
			// 					this.tableData[i].goodsList[a].twoIndex = a;
			// 				}
			// 			}
			// 		}
			// 	})
			// },
			del_goods(row,item){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.tableData[row.index].goodsList.splice(item.twoIndex,1);
				})
			},
			submit(){
				// let state = true;
				// for(let i=0;i<this.tableData.length;i++){
				// 	if(this.tableData[i].goodsList.length!==this.tableData[i].num){
				// 		state = false
				// 	}
				// }
				// if(state===false){
				// 	this.$message({
				// 		message: '套餐内的商品没有全部录入',
				// 		type: 'error'
				// 	});
				// }else{
					this.$emit('submit',{type:'success',data:this.tableData})
					console.log(this.tableData,'this.tableData');
				// }
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.label{
				display: inline-block;width:180px;text-align: right;
			}
		}
		
	}
	
</style>
